<!-- 钉钉配置 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button
        type="primary"
        @click="onCreateItem"
        v-permission="'dingtalkconfig-POST'"
      >
        <i class="fas fa-plus"></i> 新 增
      </el-button>
      <div class="former">
        <el-button
          type="warning"
          @click="onConfigItem"
          v-permission="'dingtalkconfig_config-POST'"
        >
          <i class="fas fa-cogs"></i> 配 置
        </el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      size="medium"
      :data="itemList"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="提醒名称"></el-table-column>
      <el-table-column prop="Code" label="提醒编码" width="200">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.Code }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Keyword"
        label="钉钉关键词"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="GroupName"
        label="钉钉群名"
        width="220"
      ></el-table-column>
      <el-table-column label="相关用户">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(user, index) in row.Users"
            :key="index"
            class="mr-5 mb-5"
            >{{ user.Name }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
            v-permission="'dingtalkconfig-POST'"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'dingtalkconfig-POST'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :isEdit="isEdit"
      @form:saved="getItemList"
    />
    <config-form :visible.sync="configVisible" @form:saved="getItemList" />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";
import ConfigForm from "./config-form.vue";

export default {
  components: {
    ItemForm,
    ConfigForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "Name:like": "",
        "Code:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      isEdit: false,
      configVisible: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      //获取列表
      this.loading = true;
      this.$axios
        .get("dingtalkconfig", {
          params: {
            with: ["Users"],
            ...this.pager,
            order: ["name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.isEdit = false;
      this.itemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.isEdit = true;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除该配置信息吗？", "提示")
        .then(() => this.$axios.delete(`dingtalkconfig/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        Name: "", //提醒名称
        Code: "", //提醒编码
        Keyword: "", //关键词
        Webhook: "", //钉钉群机器人消息接口
        GroupName: "", //钉钉群名
        Slient: "", //静默时间
        Remark: "", //备注
      };
    },
    onConfigItem() {
      this.configVisible = true;
    },
  },
};
</script>
